import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getSaltList } from 'components/salt/SaltAPI';
import { setSaltList, setSaltDashboardSaltList } from 'store/slice/PharmaSlice';
import SaltDashboard from '../SaltDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function SaltPageImpl() {
    const dispatch = useDispatch();
    const { saltList} = useSelector((state)=>state.pharmaslice);
    
    const getSaltListSuccess = (list) =>{dispatch(setSaltList(list));}
    useEffect(() => {
        getSaltList(()=>{}, getSaltListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setSaltDashboardSaltList( saltList));
    },[ saltList])

    return (
        < SaltDashboard />
    )

}